import type { ReactNode } from 'react';

import IntlMessages from 'components/util/IntlMessages';

interface ICookieBodyProps {
    body: ReactNode;
    updatedDate: string;
}

const CookieBody = ({ body, updatedDate }: ICookieBodyProps) => (
    <div className="cookie-consent-body">
        <div className="cookie-consent-body-content">
            {body}
            <p className="consent-updated">
                <IntlMessages id="label.lastUpdate" /> {updatedDate}
            </p>
        </div>
    </div>
);

export default CookieBody;
